import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';

export interface AuditHistoryResponse {
  content: AuditHistory[];
  page: {
    size: number;
    number: number;
    totalElements: number;
    totalPages: number;
  };
}

export interface AuditHistory {
  id: number;
  createdAt: string;
  event: string;
  actor: string;
  userId: string;
  result: 'SUCCESS' | 'FAILED' | 'ERROR';
  group?: 'Dealer' | 'Vendor';
}

export interface AuditHistorySearchRequest {
  fromDate?: string;
  toDate?: string;
  userId?: string[];
  query?: string;
  result?: 'SUCCESS' | 'FAILED' | 'ERROR';
}

@Injectable({ providedIn: 'root' })
export class AuditHistoryService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  searchAuditHistory(
    page = 0,
    size = 10,
    requestBody: AuditHistorySearchRequest = {}
  ) {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);
    return this.http.post<AuditHistoryResponse>(
      `${this.baseUrl}/admin/audit-history/search`,
      requestBody,
      { params }
    );
  }
}